import React from 'react';
import { Mail, MapPin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-light text-white mb-4">
              Baker<span className="text-amber-500">Kerry</span> Accountants
            </h3>
            <p className="text-slate-400 font-light leading-relaxed">
              Professional accounting services with over 20 years of experience. 
              Chartered Accountants you can trust.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-medium mb-4">Services</h4>
            <ul className="space-y-2">
              {['Payroll', 'Sole Traders & Partnerships', 'VAT Returns', 'Limited Companies', 'Bookkeeping'].map((service) => (
                <li key={service}>
                  <a 
                    href="#services" 
                    className="text-slate-400 hover:text-amber-500 transition-colors font-light"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-medium mb-4">Contact</h4>
            <div className="space-y-3">
              <a 
                href="mailto:BKAccountants@hotmail.co.uk"
                className="flex items-center gap-2 text-slate-400 hover:text-amber-500 transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span className="font-light">BKAccountants@hotmail.co.uk</span>
              </a>
              <a 
                href="https://www.google.com/maps/search/?api=1&query=101+Long+Hil+Rise+UK"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 text-slate-400 hover:text-amber-500 transition-colors"
              >
                <MapPin className="w-4 h-4 mt-0.5" />
                <span className="font-light">101 Long Hill Rise, Nottingham Hucknall, UK</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm font-light">
            © {currentYear} BakerKerry Accountants. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm font-light">
            Qualified Chartered Accountants Since 2001
          </p>
        </div>
      </div>
    </footer>
  );
}